<div class="d-flex flex-column g-space-sm">
  @if (this.project().name) {
    <div class="d-flex space-between align-center g-space-sm">
      <cam-item-display [label]="'project.project-profile.project-name'">
        {{ this.project().name }}
      </cam-item-display>
      @if (this.editable()) {
        <cam-font-icon class="pointer" name="modify" type="sm" (click)="this.edit.emit()"></cam-font-icon>
      }
    </div>
  }
  @if (this.project().status; as status) {
    <cam-item-display [label]="'project.project-profile.status'">
      <cam-project-status [status]="status"></cam-project-status>
    </cam-item-display>
  }
  @if (this.project().company || this.project().department) {
    <div class="info-grid">
      <cam-item-display [label]="'project.project-profile.company'">
        {{ this.project().company?.name ?? 'project.project-profile.not-available' | translate }}
      </cam-item-display>
      <cam-item-display [label]="'project.project-profile.department'">
        {{ this.project().department?.name ?? 'project.project-profile.not-available' | translate }}
      </cam-item-display>
    </div>
  }
  @if (this.project().contact; as contact) {
    <cam-item-display [label]="'project.project-profile.contact'">
      {{ fullName(contact) }}
    </cam-item-display>
  }
  @if (this.project().address; as address) {
    <div class="address-section">
      <cam-item-display [label]="'project.project-profile.address'">
        <div class="space-between align-center">
          {{
            this.fullAddress({
              city: address.city,
              country: address.countryCode,
              postCode: address.postalCode,
              street: address.street,
            })
          }}
          <cam-text-to-clipboard
            [value]="
              this.fullAddress({
                city: address.city,
                country: address.countryCode,
                postCode: address.postalCode,
                street: address.street,
              })
            "
          >
          </cam-text-to-clipboard>
        </div>
      </cam-item-display>
    </div>
  }
  @if (this.project().projectPictureUrl; as projectPictureUrl) {
    <cam-item-display [label]="'project.project-profile.project-picture'">
      <cam-card-image [src]="projectPictureUrl"></cam-card-image>
    </cam-item-display>
  }
</div>
